import { FC } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppBarLayout } from 'src/layouts';
import { HomePage } from './pages';

const AppRouter: FC = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <AppBarLayout>
              <HomePage />
            </AppBarLayout>
          }
        />
        <Route
          path="*"
          element={
            <AppBarLayout>
              <Navigate to="/" />
            </AppBarLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;
